import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  stepIconClasses,
} from "@mui/material";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import React, { useState, useContext } from "react";
import { Fragment } from "react";
import MyContext from "../../ContextServer/DataContext";
import dayjs from "dayjs";

function Chart_table(props) {
  const { myData, stinkData } = useContext(MyContext);

  const myPanel = {
    TABLE: 0,
    GRAPH: 1,
  };

  const [panelViewType, setTableShow] = useState(myPanel.TABLE);
  const tableClick = () => {
    setTableShow(myPanel.TABLE);
  };
  const graphClick = () => {
    setTableShow(myPanel.GRAPH);
  };

  //stinkTime  : YYYY-MM-DD HH:mm
  const getStinkDateTime = (stinkTime) => {
    return dayjs(stinkTime).format("MM-DD HH:mm");
  };

  var thisTime = "정보를 불러오는 중 입니다";
  var thisSite = "잠시만 기다려 주세요";
  var xAxisList = []; //chart용
  var unShiftxAxisList = []; //table용
  var airDataList = []; //chart
  var stinkDataList = []; //table
  let grade = []; //표 / 등급

  var innerNameTitle;
  var units;

  var notResult = "측정값이 없습니다";
  // console.log(stinkData[0]?.items.slice(-1)[0].intime);
  // 시간 통일 및 측정소 설정
  if (
    props.name === "초미세먼지" ||
    props.name === "미세먼지" ||
    props.name === "오존"
  ) {
    thisTime = stinkData[0]?.items.slice(-1)[0].intime + "시 기준";
    thisSite = myData[0]?.stationnm;

    myData.forEach((dataItem) => {
      // 차트용 시간 포맷만 수정
      const formatted = getStinkDateTime(dataItem?.datetime);
      xAxisList.unshift(formatted);
      unShiftxAxisList.push(formatted);
    });
  } else {
    thisTime =
      getStinkDateTime(stinkData[0]?.items.slice(-1)[0].intime) + " 기준";
    thisSite = stinkData[0]?.items[0]?.pos_nm;

    stinkData[0]?.items.forEach((stinkItem) => {
      const formatted = getStinkDateTime(stinkItem?.intime);
      xAxisList.push(formatted);
      unShiftxAxisList.unshift(formatted);
    });
  }

  // 차트+테이블 데이터

  if (props.name === "초미세먼지") {
    innerNameTitle = "초미세먼지 (㎍/㎥)";
    units = "(㎍/㎥)";
    myData.forEach((dataItem) => {
      airDataList.unshift(parseFloat(dataItem?.pm25_val));
    });
  } else if (props.name === "미세먼지") {
    innerNameTitle = "미세먼지 (㎍/㎥)";
    units = "(㎍/㎥)";
    myData.forEach((dataItem) => {
      airDataList.unshift(parseFloat(dataItem?.pm10_val));
    });
  } else if (props.name === "오존") {
    innerNameTitle = "오존 (ppm)";
    units = "(ppm)";
    myData.forEach((dataItem) => {
      airDataList.unshift(parseFloat(dataItem?.o3_val));
    });
  }

  if (props.name === "황화수소") {
    innerNameTitle = "황화수소 (ppb)";
    units = "(ppb)";
    stinkData.forEach((item) => {
      if (item.title === "황화수소") {
        item.items?.forEach((stinkItem) => {
          airDataList.push(parseFloat(stinkItem.val));
          stinkDataList.unshift(parseFloat(stinkItem.val)); //테이블
          grade.push(stinkItem.grade);
        });

        return false;
      }
    });
  } else if (props.name === "복합악취") {
    innerNameTitle = "복합악취 (배수)";
    units = "(배수)";

    stinkData?.forEach((item) => {
      if (item.title === "복합악취") {
        item.items?.forEach((stinkItem) => {
          airDataList.push(parseFloat(stinkItem.val));
          stinkDataList.unshift(parseFloat(stinkItem.val));
          grade.push(stinkItem.grade);
        });

        return false;
      }
    });
  } else if (props.name === "암모니아") {
    innerNameTitle = "암모니아 (ppb)";
    units = "(ppb)";

    stinkData?.forEach((item) => {
      if (item.title === "암모니아") {
        item.items?.forEach((stinkItem) => {
          airDataList.push(parseFloat(stinkItem.val));
          stinkDataList.unshift(parseFloat(stinkItem.val));
          grade.push(stinkItem.grade);
        });

        return false;
      }
    });
  } else if (props.name === "총휘발성유기화합물") {
    innerNameTitle = "총휘발성유기화합물(TVOC)";
    units = "(ppb)";

    stinkData?.forEach((item) => {
      if (item.title === "총휘발성유기화합물") {
        item.items?.forEach((stinkItem) => {
          airDataList.push(parseFloat(stinkItem.val));
          stinkDataList.unshift(parseFloat(stinkItem.val));
          grade.push(stinkItem.grade);
        });

        return false;
      }
    });
  }

  const options = {
    chart: {
      type: "line",
    },
    title: {
      text: "",
      align: "left",
    },
    credits: {
      enabled: false,
    },
    xAxis: {
      categories: xAxisList,
    },
    yAxis: {
      title: {
        text: `${innerNameTitle} `,
      },
    },
    legend: {
      reversed: true,
    },
    plotOptions: {
      series: {
        stacking: "normal",
        dataLabels: {
          enabled: true,
          format: "<b>{point.y}</b>",
        },
      },
    },
    colors: ["#fa8526"],
    series: [
      {
        name: "측정값",
        data: airDataList,
      },
    ],
  };

  let reverse = [...unShiftxAxisList];
  // console.log(reverse.reverse());

  return (
    <div>
      <div className="highChart">
        <div className="situation">
          <div className="rainbow">
            <div className="rainbow-box">
              <small>좋음</small>
            </div>
            <div className="rainbow-box">
              <small>보통</small>
            </div>
            <div className="rainbow-box">
              <small>나쁨</small>
            </div>
            <div className="rainbow-box">
              <small>매우나쁨</small>
            </div>
          </div>

          <h3>실시간 측정 현황</h3>
        </div>
        <div className="h3">
          <h3 style={{ color: "#000000DE", padding: 5 }}>{thisTime}</h3>
          <h3 style={{ color: "#000000DE", padding: 5, fontSize: "0.8em" }}>
            측정장소 : {thisSite}
          </h3>
          <span style={{ color: "#000000DE", padding: 5, fontSize: "0.8em" }}>
            측정물질 : {props.name}
          </span>
        </div>

        <div className="btn">
          <Button
            className={panelViewType === myPanel.TABLE ? "show" : "basic"}
            onClick={() => {
              tableClick();
            }}
          >
            표
          </Button>
          <Button
            className={panelViewType === myPanel.GRAPH ? "show" : "basic"}
            onClick={() => {
              graphClick();
            }}
          >
            그래프
          </Button>
        </div>
        <div className="contents">
          <div
            className="table"
            style={{
              display: panelViewType === myPanel.TABLE ? "block" : "none",
            }}
          >
            <TableContainer conponent={Paper} sx={{ maxHeight: 450 }}>
              <Table aria-label="simple table" stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell align="center" style={{ width: 100 }}>
                      측정값{units}
                    </TableCell>
                    <TableCell align="center" style={{ width: 20 }}>
                      등급
                    </TableCell>
                    <TableCell align="center" style={{ width: 120 }}>
                      시간
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {stinkDataList.length !== 0 ? (
                    [...stinkDataList].map((item, i) => (
                      <TableRow>
                        <TableCell
                          align="center"
                          style={{ width: 80 }}
                        >{`${item} `}</TableCell>

                        <TableCell align="center" style={{ width: 20 }}>
                          {grade[grade.length - 1 - i] === "good" ? (
                            <Button>좋음</Button>
                          ) : grade[grade.length - 1 - i] === "notice" ? (
                            <Button color={"success"}>보통</Button>
                          ) : grade[grade.length - 1 - i] === "attention" ? (
                            <Button color={"warning"}>나쁨</Button>
                          ) : grade[grade.length - 1 - i] === "warning" ||
                            grade[grade.length - 1 - i] === "over" ? (
                            <Button color={"error"}>매우나쁨</Button>
                          ) : (
                            "-"
                          )}
                        </TableCell>

                        <TableCell align="center" style={{ width: 120 }}>
                          {unShiftxAxisList[i]}
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell align="center" colSpan="2">
                        측정값이 없습니다.
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
          <div
            className="chart"
            style={{
              display: panelViewType === myPanel.GRAPH ? "block" : "none",
              textAlign: "center",
              paddingTop: "3px",
            }}
          >
            <Fragment>
              {airDataList.length !== 0 ? (
                <HighchartsReact highcharts={Highcharts} options={options} />
              ) : (
                "측정값이 없습니다."
              )}
            </Fragment>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Chart_table;
